// extracted by mini-css-extract-plugin
module.exports = {"article":"details_article__23IyT","preview":"details_preview__2uWZL","imageWrapper":"details_imageWrapper__7N4ze","time":"details_time__1so91"};